import { mapActions, mapGetters, mapMutations } from "vuex";
import statisticItem from "@/components/atoms/statistic-item/index.vue";
import chatComponent from "@/components/features/chat-component/index.vue";
import graduateWorkRate from "../../components/graduate-work-rate/index.vue";
import graduateWorkRateComment from "../../components/graduate-work-rate-comment/index.vue";
import retakingHistory from "@/components/features/graduate-work-retaking-history/index.vue";

export default {
    name: "graduate-work-report",
    data() {
        return {};
    },
    components: {
        statisticItem,
        chatComponent,
        graduateWorkRate,
        graduateWorkRateComment,
        retakingHistory,
    },
    created() {
        this.fetchItem({ courseSlug: this.$route.params.item }).then(() => {
            this.setup();
        });
    },
    mounted() {
        // land at the top after navigation/reload, not stuck at the page bottom
        this.$nextTick(() => {
            const app = document.querySelector('.app');
            if (app) app.scrollTop = 0;
            window.scrollTo(0, 0);
        });
    },
    computed: {
        ...mapGetters({
            reportResult: "coursesGraduateWork/reportResult",
            currentItem: "coursesGraduateWork/currentItem",
            isLoading: "coursesGraduateWork/isLoading",
            isLoadingReport: "coursesGraduateWork/isLoadingReport",
        }),
        hasRate() {
            return !!(
                this.reportResult &&
                this.reportResult.graduateWork.data.userRating.data.rating
            );
        },
        canBeRated() {
            return !!(
                this.reportResult &&
                ["accepted", "failed", "expired"].includes(this.reportResult.status)
            );
        },
    },
    methods: {
        ...mapActions({
            fetchData: "coursesGraduateWork/GET_REPORT",
            fetchItem: "coursesGraduateWork/GET_LIST_ITEM",
        }),
        ...mapMutations({
            changeHeader: "coursesGraduateWork/CHANGE_HEADER",
            setReportResult: "coursesGraduateWork/SET_REPORT_RESULT",
            setItem: "coursesGraduateWork/SET_ITEM",
            setQuestion: "coursesGraduateWork/SET_CURRENT_QUESTION",
        }),
        setup() {
            this.fetchData({
                courseSlug: this.$route.params.item,
                graduateWorkId: this.$route.params.graduateWorkId,
            }).catch((error) => {
                if (error.response.status === 403) {
                    // this.$toasted.error(error.response.data.error.message_key);
                    try {
                        this.$router.push({
                            name: "graduate-work-check",
                            params: {
                                graduateWorkId: this.$route.params.graduateWorkId,
                                item: this.$route.params.item,
                            },
                        });
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
            this.changeHeader({
                show: true,
                title: this.$t("resultsOfDiplomaWork"),
                parentRoute: {
                    name: "courses-main",
                    params: { item: this.$route.params.item },
                },
            });
        },
        navigateTo(route) {
            try {
                this.$router.push({
                    name: route,
                    params: {
                        graduateWorkId: this.$route.params.graduateWorkId,
                        item: this.$route.params.item,
                    },
                });
            } catch (e) {
                console.log(e);
            }
        },
    },
    destroyed() {
        this.setReportResult(null);
        this.setItem(null);
        this.setQuestion(null);
        this.changeHeader({
            show: false,
            title: "",
            currentTime: "",
            availableTime: "",
            parentRoute: "",
        });
    },
};
